export const ProductStatus = {
  STATUS_AVAILABLE: 1,
  STATUS_RESERVATION: 2,
  STATUS_NOT_FOR_SALE: 5
};
